import * as Types from '../../graphql/generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CompleteAndChargeInvoiceRunMutationVariables = Types.Exact<{
  generation_run_id: Types.Scalars['UUID'];
}>;


export type CompleteAndChargeInvoiceRunMutation = { __typename?: 'Mutation', completeAndChargeInvoiceRun: { __typename?: 'InvoiceRun', id: string, status: Types.InvoiceRunStatus, parent_run_id?: string | null } };


export const CompleteAndChargeInvoiceRunDocument = gql`
    mutation CompleteAndChargeInvoiceRun($generation_run_id: UUID!) {
  completeAndChargeInvoiceRun(generation_run_id: $generation_run_id) {
    id
    status
    parent_run_id
  }
}
    `;
export type CompleteAndChargeInvoiceRunMutationFn = Apollo.MutationFunction<CompleteAndChargeInvoiceRunMutation, CompleteAndChargeInvoiceRunMutationVariables>;

/**
 * __useCompleteAndChargeInvoiceRunMutation__
 *
 * To run a mutation, you first call `useCompleteAndChargeInvoiceRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteAndChargeInvoiceRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeAndChargeInvoiceRunMutation, { data, loading, error }] = useCompleteAndChargeInvoiceRunMutation({
 *   variables: {
 *      generation_run_id: // value for 'generation_run_id'
 *   },
 * });
 */
export function useCompleteAndChargeInvoiceRunMutation(baseOptions?: Apollo.MutationHookOptions<CompleteAndChargeInvoiceRunMutation, CompleteAndChargeInvoiceRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteAndChargeInvoiceRunMutation, CompleteAndChargeInvoiceRunMutationVariables>(CompleteAndChargeInvoiceRunDocument, options);
      }
export type CompleteAndChargeInvoiceRunMutationHookResult = ReturnType<typeof useCompleteAndChargeInvoiceRunMutation>;
export type CompleteAndChargeInvoiceRunMutationResult = Apollo.MutationResult<CompleteAndChargeInvoiceRunMutation>;
export type CompleteAndChargeInvoiceRunMutationOptions = Apollo.BaseMutationOptions<CompleteAndChargeInvoiceRunMutation, CompleteAndChargeInvoiceRunMutationVariables>;